export enum WaterAccessible {
    TownWater = 'Town Water',
    TankBore = 'Tank/Bore',
}
